import ServicesRegistration from './ServicesRegistration';

export default ServicesRegistration;